import { cn } from '@/lib/utils';

import styles from '../../booking.module.css';

export const StepsWrapper = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}): JSX.Element => {
  return (
    <div
      className={cn('row row-cols-1 row-cols-md-3 gap-3 gap-md-0', styles.stepsWrapper, className)}
    >
      {children}
    </div>
  );
};
